const DEFAULT_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://femtyz-admin.pixoatic.in/";

const inflightGetRequests = new Map();

function getToken() {
  try {
    return localStorage.getItem("femtyz_token");
  } catch {
    return null;
  }
}

export async function apiRequest(
  path,
  { method = "GET", body, headers, token: tokenOverride, signal } = {}
) {
  const token = tokenOverride !== undefined ? tokenOverride : getToken();
  const normalizedMethod = String(method || "GET").toUpperCase();
  const url = `${DEFAULT_BASE_URL}${path}`;

  const isDedupableGet = normalizedMethod === "GET" && !body && !signal;
  const inflightKey = isDedupableGet
    ? `${normalizedMethod} ${url} :: ${token ? "auth" : "anon"}`
    : "";

  if (isDedupableGet && inflightGetRequests.has(inflightKey)) {
    return inflightGetRequests.get(inflightKey);
  }

  const requestPromise = (async () => {
    const res = await fetch(url, {
      method: normalizedMethod,
      signal,
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(headers || {}),
      },
      body: body ? JSON.stringify(body) : undefined,
    });

    const data = await res.json().catch(() => ({}));
    return { ok: res.ok, status: res.status, data };
  })();

  if (isDedupableGet) {
    inflightGetRequests.set(inflightKey, requestPromise);
    requestPromise.finally(() => {
      inflightGetRequests.delete(inflightKey);
    });
  }

  return requestPromise;
}

export const API_BASE_URL = DEFAULT_BASE_URL;

export function getAuthHeader() {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

